export default {
  developer: {}
};
